import React from 'react';
import { CheckupTag } from '@companion-professional/dctypes';
import { BadgeProps } from '@companion-professional/components';
import { Building, CalendarCheck, Home, Tag } from 'lucide-react';

export type TagBadge = {
  // variant is the Badge variant (brand status tint) used to display the tag.
  variant: NonNullable<BadgeProps['variant']>;
  icon: React.ComponentType<{ className?: string }>;
};

// This is mostly here because I wanted to make things pretty.  This is a mapping of the tags to the Badge variant and
// icon that should be displayed for that tag.
export const tagBadgeDisplay: Record<CheckupTag, TagBadge> = {
  in_home: {
    variant: 'success',
    icon: Home
  },
  in_clinic: {
    variant: 'info',
    icon: Building
  },
  at_event: {
    variant: 'warning',
    icon: CalendarCheck
  }
};

// This is the default tag badge that will be used if a tag is not in the tagBadgeDisplay mapping.
export const defaultTagBadge: TagBadge = {
  variant: 'muted',
  icon: Tag
};
